import Image from "./image";

var reducers = {
  data: Image,
};

export default reducers;
